<template>
  <div>
    <JZ />
    <JG />
    <GPS />
    <NT />
    <DQ />
  </div>
</template>
<script>
import axios from "axios";
import JZ from "./JZ";
import JG from "./JG";
import GPS from "./GPS";
import NT from "./NT";
import DQ from "./DQ";
export default {
  components: {
    JZ,
    JG,
    GPS,
    NT,
    DQ,
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    axios.get("/jz/jz.json").then((result) => {
      this.list = result.data;
      console.log("result:", result);
    });
  },
};
</script>
<style lang="scss" scoped>
.ZX {
  .nei_container {
    margin: 25px auto;
    width: 1200px;
    .text_c {
      text-align: center;
      .index_title {
        font-size: 30px;
        line-height: 50px;
        position: relative;
        text-align: center;
        &::before {
          display: block;
          height: 1px;
          top: 50%;
          width: 100%;
          left: 0px;
          background: #d7d7d7;
          position: absolute;
          content: "";
        }
        .index_ts {
          display: inline-block;
          font-size: 24px;
          background: #fff;
          padding: 0px 50px;
          position: relative;
          z-index: 1;
        }
        .index_tp {
          display: inline-block;
          font-size: 18px;
          background: #fff;
          padding: 0px 50px;
          position: relative;
          z-index: 1;
          color: #ccc;
          margin-top: -5px;
        }
      }
    }
    .newsbox {
      margin: 20px auto;
      padding: 20px 0px;
      border-top: 1px solid #d7d7d7;
      .newsbox_li {
        padding: 20px 0px;
        border-bottom: 1px solid #d7d7d7;
        cursor: pointer;
        .newsbox_liimg {
          width: 225px;
          float: left;
          img {
            display: block;
            width: 100%;
          }
        }
        .newsbox_litxt {
          margin-left: 260px;
          .t {
            font-size: 18px;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .date {
            margin: 5px 0px;
            font-size: 14px;
            color: #999;
          }
          .c {
            margin: 10px 0px;
            font-size: 14px;
            line-height: 22px;
            color: #666;
            height: 44px;
            overflow: hidden;
          }
          .newsbox_a {
            display: block;
            width: 85px;
            height: 25px;
            border: 1px solid #1a6fc9;
            font-size: 14px;
            line-height: 25px;
            color: #1a6fc9;
            text-align: center;
            text-decoration: none;
          }
        }
      }
    }
  }
}
</style>